$('.entry-content').append($('#shopify-section-template--16055192977595__1660701119bf6e40d7'));

		(function () {
          
           // store the slider in a local variable
            var $window = $(window),
                flexslider = { vars:{} };
           
            // tiny helper function to add breakpoints
            function getGridSize() {
              return (window.innerWidth < 600) ? 2 :
                     (window.innerWidth < 900) ? 3 : 3;
            }
          
			function onload() {
              
				window.$ = window.wetheme.$;

                $('.flexslider.logos').flexslider({
                    slideshow: false,
					animation: "slide",
					itemWidth: 160,
					itemMargin: 15,
					minItems: 3,
                    maxItems: 5
       
				});
              
				$('.flexslider').flexslider({
                    slideshow: false,
					animation: "slide",
					itemWidth: 210,
					itemMargin: 15,
                   // controlsContainer: $(".custom-controls-container"),
                   // customDirectionNav: $(".custom-navigation a"),
					minItems: getGridSize(), // use function to pull in initial value
                    maxItems: getGridSize() // use function to pull in initial value
       
				});

              
			}

          
            // check grid size on resize event
              $window.resize(function() {
                var gridSize = getGridSize();
             
                flexslider.vars.minItems = gridSize;
                flexslider.vars.maxItems = gridSize;
              });
          
			document.addEventListener('shopify:section:load', onload);
			window.addEventListener('load', onload);

		})();